module.exports = __webpack_public_path__ + "static/img/brees-2017-slide-7.8d56831.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2017-slide-7.jpg
// module id = JYIt
// module chunks = 1